import { Tab, TabContext, TabList } from '@global-engineering-shared/gweb-material-ui';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  FRAMES_PAGE_URL,
  HEALTH_PAGE_URL,
  LAST_24_HOUR_QUERY_PARAMS,
  SEARCH_PAGE_URL,
} from 'utils/defaults';

const Navigation = () => {
  const [value, setValue] = useState('0');

  const navigate = useNavigate();
  const location = useLocation();

  const handleTabClick = (url: string) => {
    navigate(`${url}`);
  };

  useEffect(() => {
    if (location.pathname === HEALTH_PAGE_URL) {
      setValue('0');
    } else if (
      location.pathname.includes(FRAMES_PAGE_URL) ||
      location.pathname.includes(SEARCH_PAGE_URL)
    ) {
      setValue('1');
    }
  }, [location.pathname]);

  return (
    <>
      <TabContext value={value}>
        <TabList>
          <Tab
            label="Health"
            value="0"
            onClick={() => handleTabClick(HEALTH_PAGE_URL + LAST_24_HOUR_QUERY_PARAMS)}
          />
          <Tab label="Frames" value="1" onClick={() => handleTabClick(FRAMES_PAGE_URL)} />
        </TabList>
      </TabContext>
    </>
  );
};

export default Navigation;
